

exports.createSelectStateSystem = ({$scope,sendMessageSystem})=>{

    const sendSoundset = () => sendMessageSystem.send('mi.selectedSoundset', $scope.selected_soundset)
    const sendMood = () => sendMessageSystem.send('mi.selectedMood', $scope.selected_mood)
    const sendElement = () =>
			sendMessageSystem.send(
				'mi.selectedElement',
				Object.assign(
					{
						can_edit: $scope.user_can_edit_selected_element(),
					},
					$scope.selected_element
				)
			)

	const sendInitialUrlParams = () =>
		sendMessageSystem.send('mi.initialUrlParams', $scope.getInitialValues())

    $scope.$watch('selected_soundset', sendSoundset)
    $scope.$watch('selected_mood',sendMood)
    $scope.$watch('selected_element', sendElement)

    return {
        handleRequestState:()=>{
            sendSoundset()
            sendMood()
            sendElement()
        },
        handleRequestInitialUrlParams:()=>{
            sendInitialUrlParams()
        },
        handleSetUrlParam:({key,value})=>
            $scope.setUrlParam(key,value)
    }
}



// WEBPACK FOOTER //
// ./djangosite/master/frontend/src/search-panel/selectStateSystem.js